import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"

export const getUserDefinitions = () => get(url.USER_DEFINITIONS)
export const getUserDefinitionsByUserName = userName => get(`${url.USER_DEFINITIONS_BY_USERNAME}?userName=${userName}`,{params:{userName}})
export const addNewUserDefinition = userDefinition => post(url.USER_INSERT, userDefinition)
export const updateUserDefinition = userDefinition => put(url.USER_UPDATE, userDefinition)
export const deleteUserDefinition = guid => del(url.USER_DELETE, { params: { guid } })
export const addNewCreateUserAcount = userDefinition => post(url.USER_CREATE, userDefinition)
export const confirmUserAcount = token => get(url.USER_CONFIRM, { params: { token } })
